module.exports = __webpack_public_path__ + "img/revolve.b8bd9cb.svg";